/**
 * Cache en memoria de tickets.alumno.info por id_alumno.
 * Evita reconsultar al abrir el mismo ticket varias veces en la sesión.
 * TTL: 15 min (grupo/ciclo pueden cambiar).
 */
const TTL_MS = 15 * 60 * 1000
const cache = new Map()
const inflight = new Map()

function keyOf (id) {
  return String(id)
}

export function getCachedInfoAlumno (idAlumno) {
  const key = keyOf(idAlumno)
  const hit = cache.get(key)
  if (!hit) return null
  if (Date.now() - hit.at > TTL_MS) {
    cache.delete(key)
    return null
  }
  return hit.data
}

export function setCachedInfoAlumno (idAlumno, data) {
  cache.set(keyOf(idAlumno), { data, at: Date.now() })
}

/**
 * Devuelve info del alumno; usa cache o una sola petición en vuelo por id.
 * @param {object} http - this.$http (vue-resource)
 * @param {number|string} idAlumno
 */
export function fetchInfoAlumno (http, idAlumno) {
  const key = keyOf(idAlumno)
  const cached = getCachedInfoAlumno(key)
  if (cached) {
    return Promise.resolve(cached)
  }
  if (inflight.has(key)) {
    return inflight.get(key)
  }

  const req = http.get('tickets.alumno.info/' + key).then((response) => {
    const data = response.body || response.data
    setCachedInfoAlumno(key, data)
    inflight.delete(key)
    return data
  }).catch((error) => {
    inflight.delete(key)
    throw error
  })

  inflight.set(key, req)
  return req
}
